module.exports = __webpack_public_path__ + "static/img/about-us-img@t.f115013.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/haevichi/about-us-img@t.png
// module id = SAfD
// module chunks = 0